export { ViewSuccess } from './view-success.component';
